import KYCLevelBannerBackground from "@components/KYCLevelBannerBackground/KYCLevelBannerBackground"
import KYCLevelNumber from "@components/KYCLevelNumber/KYCLevelNumber"
import { KYC_LEVELS } from "@constants/kyc"
import { Container, LevelWrapper, LevelName, BackgroundWrapper } from "./KYCLevelBanner.styles"
import { useTranslation } from "react-i18next"

const KYCLevelBanner = ({ level }: { level: number }) => {
    const { t } = useTranslation();
    
    return (
        <Container $backgroundColor={KYC_LEVELS[level].bannerColor}>
            <span>{t('components.kycLevelBanner.yourLevel')}</span>
            <LevelWrapper>
                <KYCLevelNumber number={level} />
                <LevelName>
                    {KYC_LEVELS[level].name}
                </LevelName>
                <BackgroundWrapper>
                    <KYCLevelBannerBackground />
                </BackgroundWrapper>
            </LevelWrapper>
        </Container>
    )
}

export default KYCLevelBanner
